export default Object.assign(
    {},
    // process.env,
    process.env,
    //@ts-ignore
    document.ENV
)